export default function calledstatuses(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                calledstatus: action.calledstatus,
            }
        default:
            return state;
    }
}
